// extracted by mini-css-extract-plugin
export default {"btnAdd":"document-comment-form_btnAdd__jKmYb"};